export interface MastermindSidebarTitle {
	value: string;
	link: string;
}

export const mastermindTitles: MastermindSidebarTitle[] = [
	{ value: 'Mastermind Ocean Capital przymierze umysłów', link: '/mastermind/przymierze-umyslow' },
	{ value: 'Co uzyskasz dla siebie z udziału w mastermind?', link: '/mastermind/korzysci' },
	{ value: 'Tematyka spotkań wybrana dla Ciebie', link: '/mastermind/tematyka' },
	{ value: 'Rodzaje grup, dla kogo, cele', link: '/mastermind/grupy' },
	{ value: 'Jak pracujesz z nami i jak zorganizowana jest praca', link: '/mastermind/forma-pracy' },
	{ value: 'FORMOWANIE GRUP I KONTAKT', link: '/mastermind/grupy-i-kontakt' },
];

export interface MastermindPages {
	[key: string]: any;
	'/mastermind/przymierze-umyslow'?: string;
	'/mastermind/korzysci'?: string;
	'/mastermind/tematyka'?: string;
	'/mastermind/grupy'?: string;
	'/mastermind/forma-pracy'?: string;
	'/mastermind/grupy-i-kontakt'?: string;
}

// z cytatami
// export const mastermindTexts: string[] = [
// 	'_„Umysł ludzki można porównać do baterii elektrycznej. Ogólnie wiadomo, że zespół baterii elektrycznych wytwarza więcej energii od baterii pojedynczej._\n\n_Żaden umysł nie jest kompletny sam w sobie. Każdy potrzebuje połączenia i kontaktu_  \n_z innymi umysłami, aby wzrastać i rozszerzać swoją świadomość.”_\n\nNapoleon Hill\n\n# MASTERMIND OCEAN CAPITAL\n\nIntensywny program pracy grupowej, przeznaczony dla liderek i liderów, skupiony na rozwiązywaniu konkretnych zadań i wyzwań własnych przedsięwzięć biznesowych. Uczestniczki i uczestnicy spotkań osiągają swoje cele poprzez współpracę, wymianę wiedzy, doświadczeń, pomysłów, kontaktów, rozwój osobisty oraz pracę z mentorem prowadzącym. \n\nMASTERMIND OCEAN CAPITAL tworzy cykl 12 lub 24 regularnych spotkań w ciągu 12 miesięcy, zorganizowanych grup współczesnych liderek i liderów.  Uczestniczki i uczestnicy spotkań tworzą „przymierze umysłów”, łącząc swoje kompetencje do realizacji konkretnych zadań i wyzwań liderskich. W moderowanej pracy grupowej dochodzi do wymiany doświadczeń, wiedzy, pomysłów i kontaktów tak, aby wspierać, rozwijać i inspirować się nawzajem. \n\nWspólna praca we wspólnym celu wypełnia każdą z uczestniczek i uczestników energią, pomysłami i sprawczością działania oraz przezwyciężania wyzwań znacznie mocniej niż dzieje się to, kiedy działają oni w pojedynkę lub w małych, zamkniętych zespołach. \n\nUdział w spotkaniach MASTERMIND OCEAN CAPITAL stanowi również platformę rozwoju osobistego, a co za tym idzie rozwoju całych zespołów, z którymi liderki i liderzy pracują każdego dnia.\n\nGrupy MASTERMIND OCEAN CAPITAL tworzą osoby reprezentujące różne branże i specjalizacje, przedsięwzięcia na podobnym etapie rozwoju, posiadające podobne cele oraz mierzące się z podobnymi wyzwaniami. Taka formuła pracy adresuje m.in. problem samotności lidera, umożliwia holistyczne ujęcie i zrozumienie każdego tematu, tworzy przestrzeń do rozważania pojawiających się wyzwań, ich analizowania z różnych perspektyw celem znalezienia konkretnych, najbardziej efektywnych rozwiązań.\n\nMASTERMIND OCEAN CAPITAL powstało na bazie kilkudziesięciu lat doświadczeń biznesowych, mentoringowych i szkoleniowych zespołu OCEAN CAPITAL. \n\n _„Grupa mastermind” oraz „przymierze umysłów” to koncepcje wprowadzone przez autora i myśliciela Napoleona Hilla w jego książce "Myśl i bogać się" ("Think and Grow Rich")._',
// 	'- W ramach „przymierza umysłów” poszerzysz grono liderskie własnej firmy lub przedsięwzięcia.\n- Pozyskasz nową, praktyczną wiedzę.\n- Wymienisz doświadczenia, pomysły, inspiracje i sprawdzone w działaniu rozwiązania.\n- Doświadczysz spojrzenia na Twoje wyzwania oczami innych liderek i liderów.\n- Zmienisz perspektywę. Być może wywrócisz dotychczasowe koncepcje do góry nogami.\n- Uzyskasz dostęp do „success story”oraz „case study” innych liderek i liderów, jak również do lekcji, które dały im popełnione błędy.\n- Będziesz podejmowała/podejmował właściwe decyzje biznesowe, wynikające z mądrego procesu grupowego.\n- Unikniesz samotności, która dosięga wielu liderów na różnych etapach życia.\n- Wpłyniesz na kształtowanie kultury organizacyjnej w swojej organizacji tak by zespoły lepiej funkcjonowały w procesach zmian.\n- Rozwiniesz umiejętność zarządzania sobą oraz budowania trwałych i sprawczych relacji.\n- Rozwiniesz umiejętność słuchania oraz szacunku dla ludzi o odmiennych spojrzeniach na te same sprawy\n- Poznasz i rozwiniesz różne style komunikacji\n- Nabędziesz nowe kompetencje przywódcze i analityczne.\n- Nawiążesz i rozwiniesz relacje z liderami innych firm i branż.\n- Zadbasz o swój dobrostan i równowagę w życiu i biznesie.',
// 	'Pracujesz z zadaniami z własnego życia zawodowego oraz z życia członków grupy MASTERMIND OCEAN CAPITAL  \n Tematy, zadania i wyzwania zgłaszane i proponowane są przez uczestniczki i uczestników  \n Tematy proponowane są także przez Mentora, w zależności od dynamiki pracy oraz konkretnych potrzeb członków grupy - przykłady:\n- Po co Liderka/Lider/CEO/General Manager/Szef w organizacji?\n- Jedyną stałą rzeczą w życiu jest zmiana. Oczywistość? Co z tego wynika?\n- Strategia firmy. Po co Twojej firmie strategia? Czy warto ją rewidować?\n- AI - szanse i zagrożenia dla Twojego biznesu\n- Demony KPI. Do czego służą wskaźniki KPI? Jak je wyznaczać i wdrażać w Twojej organizacji?\n- Jak pozyskiwać najlepsze talenty i jak budować wraz z nimi zespoły?\n- Mobbing. Co jest a co nie jest mobbingiem? Czy występuje on w Twojej organizacji? Czy i jak temu przeciwdziałasz?\n- Komunikacja wewnętrzna i zewnętrzna między wszystkimi interesariuszami przedsięwzięć\n- Styl komunikacji lidera jako czynnik sukcesu w prowadzeniu zespołu\n- Kintsugi - sztuka uczenia się na błędach jako element prowadzenia zespołów w dynamicznym świecie (praca na metaforze pozłacanej, japońskiej porcelany - proces grupowy)\n- Trójkąt dramatyczny. Dlaczego jest ważny Twoim w życiu osobistym i w biznesie?\n- Feedback jest darem? Czy krytyka jest feedbackiem? Jak wdrażać i stosować feedback w Twojej organizacji?\n- Strach ma wielkie oczy. W jaki sposób strach determinuje nasze myślenie, a w jaki sposób to przekłada się na (nie)działanie?\n- Warsztaty właścicielskie: rynki, konkurencja, spółka, proces inwestycyjny i sprzedaż firmy\n- Sukcesja. Kiedy i jak przekazać firmę w inne ręce?',
// 	'# RODZAJE GRUP MASTERMIND OCEAN CAPITAL\nOCEAN CAPITAL organizuje grupy MASTERMIND w następujących wariantach:\nLiderki i liderzy z różnych branż i specjalizacji\nGrupy osób z jednej organizacji, odpowiedzialne za różne obszary działalności\nPrzedstawiciele różnych organizacji z tej samej branży, np. bankowość i finanse, software i IT, ochrona zdrowia i produkty medyczne, FMCG, produkcja, prawo, administracja publiczna, start-upy\nMastermind dla absolwentów Executive MBA\n# DLA KOGO PRZEZNACZONE SĄ GRUPY MASTERMIND OCEAN CAPITAL\nUdział w MASTERMIND OCEAN CAPITAL szczególnie polecany jest osobom pełniącym następujące funkcje w organizacjach:\nLiderki i liderzy \nPrezesi i członkowie zarządów\nZałożyciele, właściciele i udziałowcy\nCzłonkowie rad nadzorczych \n… oraz osoby bezpośrednio z nimi współpracujące lub kandydatki i kandydaci do powyższych ról.\n\n [https://oceancapital.pl/dla-kogo](https://oceancapital.pl/dla-kogo)',
// 	'# JAK PRACUJESZ Z NAMI\n- Dołączasz do grupy liderskiej i razem tworzycie „przymierze umysłów”\n- Pracujesz w grupie liderów będących na podobnym etapie rozwoju biznesowego i życiowego, co nie jest możliwe w innym miejscu i czasie\n- Pracujesz nad swoim przedsięwzięciem oraz przedsięwzięciami osób z grupy\n- Dostajesz od innych, dajesz innym\n- Otrzymujesz stałe wsparcie i moderację doświadczonego mentora\n- Uczysz się i rozwijasz holistycznie przedsiębiorczość, strategię, finanse, przywództwo, komunikację i relacje, i inne, kluczowe dla Twojego sukcesu obszary liderskie \n- Rozwiązujesz konkretne zadania\n- Pozyskujesz nową wiedzę i doświadczenia \n- Koncentrujesz się na ludziach, przedsięwzięciach i konkretnych potrzebach swoich i innych uczestniczek i uczestników\n- Bierzesz udział w holistycznym ujmowaniu tematów\n- Doświadczasz inspirujących spotkań warsztatowych\n- Doświadczasz wyjątkowego procesu pracy i rozwoju\n- Budujesz dobre życie: Twoje, Twojego zespołu, Twojej firmy.\n\n# JAK ZORGANIZOWANA JEST PRACA\n- Pracujesz w grupie 6-10 osób\n- Twoim mentorem prowadzącym jest Tomasz Dalach: https://oceancapital.pl/mentoring/tomasz-dalach\n- Bierzesz udział w regularnych, zorganizowanych spotkaniach stacjonarnych lub on-line w aplikacji Zoom ustalanych indywidualnie\n- Ustalamy wspólnie częstotliwość: co 2 (dla spotkań 1,5h) lub co 4 (dla spotkań 3h) tygodnie, stałe dni i godziny tygodnia, np. piątek, godz. 9:00 lub 12:00 lub 15:00 \n- Uzyskujesz nielimitowany kontakt i możliwość współpracy z uczestniczkami i uczestnikami\n- Tworzysz grupę WhatsApp z udziałem innych uczestniczek, uczestników oraz mentora prowadzącego\n- Pracujesz z tematami proponowanymi przez siebie oraz przez uczestniczki i uczestników,  stanowiącymi  wyzwania indywidualne lub organizacyjne każdej osoby lub firmy\n- Pracujesz z tematami proponowanymi i przygotowywanymi przez mentora prowadzącego \n- Uzyskujesz wsparcie w organizacji nieformalnych spotkań grupy',
// 	'Rekrutacja przebiega ciągłe w trakcie roku kalendarzowego. Grupy tworzone są na bieżąco w uzgodnieniu z zainteresowanymi uczestniczkami i uczestnikami, mają charakter stały i zamknięty. Obecnie prowadzimy rekrutację na edycję 2024/2025.\n\nFormowanie grup odbywa się w następujących etapach: - Spotkanie informacyjne\n- Rozmowa z Mentorem o potrzebach i oczekiwaniach liderskich zainteresowanej osoby lub zespołu\n - Uszczegółowienie programu tak, aby dostosować go do potrzeb Grupy\n- Ustalenie harmonogramu spotkań\n - Rozpoczęcie spotkań MASTERMIND\n\nJeśli MASTERMIND OCEAN CAPITAL może wesprzeć Ciebie, rozwój Twojego zespołu oraz biznesu, umów się na bezpłatne spotkanie informacyjne - kliknij [tutaj](https://oceancapital.pl/kontakt/umow-spotkanie).',
// ];

export const mastermindTexts: MastermindPages = {
	'/mastermind/przymierze-umyslow': `
Intensywny program pracy grupowej, przeznaczony dla liderek i liderów, skupiony na rozwiązywaniu konkretnych zadań i wyzwań własnych przedsięwzięć biznesowych. Uczestniczki i uczestnicy spotkań osiągają swoje cele poprzez współpracę, wymianę wiedzy, doświadczeń, pomysłów, kontaktów, rozwój osobisty oraz pracę z mentorem prowadzącym. 

MASTERMIND OCEAN CAPITAL tworzy cykl regularnych spotkań zorganizowanych grup współczesnych liderek i liderów. Uczestniczki i uczestnicy spotkań tworzą „przymierze umysłów”, łącząc swoje kompetencje do realizacji konkretnych zadań i wyzwań liderskich. W moderowanej pracy grupowej dochodzi do wymiany doświadczeń, wiedzy, pomysłów i kontaktów tak, aby wspierać, rozwijać i inspirować się nawzajem.

Wspólna praca we wspólnym celu wypełnia każdą z uczestniczek i uczestników energią, pomysłami i sprawczością działania oraz przezwyciężania wyzwań znacznie mocniej niż dzieje się to, kiedy działają oni w pojedynkę lub w małych, zamkniętych zespołach.

Udział w spotkaniach MASTERMIND OCEAN CAPITAL stanowi również platformę rozwoju osobistego, a co za tym idzie rozwoju całych zespołów, z którymi liderki i liderzy pracują każdego dnia.

Grupy MASTERMIND OCEAN CAPITAL tworzą osoby reprezentujące różne branże i specjalizacje, przedsięwzięcia na podobnym etapie rozwoju, posiadające podobne cele oraz mierzące się z podobnymi wyzwaniami. Taka formuła pracy adresuje m.in. problem samotności lidera, umożliwia holistyczne ujęcie i zrozumienie każdego tematu, tworzy przestrzeń do rozważania pojawiających się wyzwań, ich analizowania z różnych perspektyw celem znalezienia konkretnych, najbardziej efektywnych rozwiązań.

MASTERMIND OCEAN CAPITAL powstało na bazie kilkudziesięciu lat doświadczeń biznesowych, mentoringowych i szkoleniowych zespołu OCEAN CAPITAL.

_„Grupa mastermind” oraz „przymierze umysłów” to koncepcje wprowadzone przez autora i myśliciela Napoleona Hilla w jego książce "Myśl i bogać się" ("Think and Grow Rich")._`,

	'/mastermind/korzysci': `
- W ramach „przymierza umysłów” poszerzysz grono liderskie własnej firmy lub przedsięwzięcia.
- Pozyskasz nową, praktyczną wiedzę.
- Wymienisz doświadczenia, pomysły, inspiracje i sprawdzone w działaniu rozwiązania.
- Doświadczysz spojrzenia na Twoje wyzwania oczami innych liderek i liderów.
- Zmienisz perspektywę. Być może wywrócisz dotychczasowe koncepcje do góry nogami.
- Uzyskasz dostęp do „success story”oraz „case study” innych liderek i liderów, jak również do lekcji, które dały im popełnione błędy.
- Będziesz podejmowała/podejmował właściwe decyzje biznesowe, wynikające z mądrego procesu grupowego.
- Unikniesz samotności, która dosięga wielu liderów na różnych etapach życia.
- Wpłyniesz na kształtowanie kultury organizacyjnej w swojej organizacji tak by zespoły lepiej funkcjonowały w procesach zmian.
- Rozwiniesz umiejętność zarządzania sobą oraz budowania trwałych i sprawczych relacji.
- Rozwiniesz umiejętność słuchania oraz szacunku dla ludzi o odmiennych spojrzeniach na te same sprawy
- Poznasz i rozwiniesz różne style komunikacji
- Nabędziesz nowe kompetencje przywódcze i analityczne.
- Nawiążesz i rozwiniesz relacje z liderami innych firm i branż.
- Zadbasz o swój dobrostan i równowagę w życiu i biznesie.
`,
	'/mastermind/tematyka': `
Pracujesz z zadaniami z własnego życia zawodowego oraz z życia członków grupy MASTERMIND OCEAN CAPITAL  
Tematy, zadania i wyzwania zgłaszane i proponowane są przez uczestniczki i uczestników  
Tematy proponowane są także przez Mentora, w zależności od dynamiki pracy oraz konkretnych potrzeb członków grupy - przykłady:
- Po co Liderka/Lider/CEO/General Manager/Szef w organizacji?
- Jedyną stałą rzeczą w życiu jest zmiana. Oczywistość? Co z tego wynika?
- Strategia firmy. Po co Twojej firmie strategia? Czy warto ją rewidować?
- AI - szanse i zagrożenia dla Twojego biznesu
- Demony KPI. Do czego służą wskaźniki KPI? Jak je wyznaczać i wdrażać w Twojej organizacji?
- Jak pozyskiwać najlepsze talenty i jak budować wraz z nimi zespoły?
- Mobbing. Co jest a co nie jest mobbingiem? Czy występuje on w Twojej organizacji? Czy i jak temu przeciwdziałasz?
- Komunikacja wewnętrzna i zewnętrzna między wszystkimi interesariuszami przedsięwzięć
- Styl komunikacji lidera jako czynnik sukcesu w prowadzeniu zespołu
- Kintsugi - sztuka uczenia się na błędach jako element prowadzenia zespołów w dynamicznym świecie (praca na metaforze pozłacanej, japońskiej porcelany - proces grupowy)
- Trójkąt dramatyczny. Dlaczego jest ważny Twoim w życiu osobistym i w biznesie?
- Feedback jest darem? Czy krytyka jest feedbackiem? Jak wdrażać i stosować feedback w Twojej organizacji?
- Strach ma wielkie oczy. W jaki sposób strach determinuje nasze myślenie, a w jaki sposób to przekłada się na (nie)działanie?
- Warsztaty właścicielskie: rynki, konkurencja, spółka, proces inwestycyjny i sprzedaż firmy
- Sukcesja. Kiedy i jak przekazać firmę w inne ręce?
- Dobre życie, czyli…?`,

	'/mastermind/grupy': `
# RODZAJE GRUP MASTERMIND OCEAN CAPITAL
OCEAN CAPITAL organizuje grupy MASTERMIND w następujących wariantach:
- Liderki i liderzy z różnych branż i specjalizacji
- Grupy osób z jednej organizacji, odpowiedzialne za różne obszary działalności
- Przedstawiciele różnych organizacji z tej samej branży, np. bankowość i finanse, software i IT, ochrona zdrowia i produkty medyczne, FMCG, produkcja, prawo, administracja publiczna, start-upy
- Mastermind dla absolwentów Executive MBA

# DLA KOGO PRZEZNACZONE SĄ GRUPY MASTERMIND OCEAN CAPITAL
Udział w MASTERMIND OCEAN CAPITAL szczególnie polecany jest osobom pełniącym następujące funkcje w organizacjach:
- Liderki i liderzy 
- Prezesi i członkowie zarządów
- Założyciele, właściciele i udziałowcy
- Członkowie rad nadzorczych 
- oraz osoby bezpośrednio z nimi współpracujące lub kandydatki i kandydaci do powyższych ról.

[https://oceancapital.pl/dla-kogo](https://oceancapital.pl/dla-kogo)`,

	'/mastermind/forma-pracy': `
# JAK PRACUJESZ Z NAMI
- Dołączasz do grupy liderskiej i razem tworzycie „przymierze umysłów”
- Pracujesz w grupie liderów będących na podobnym etapie rozwoju biznesowego i życiowego, co nie jest możliwe w innym miejscu i czasie
- Pracujesz nad swoim przedsięwzięciem oraz przedsięwzięciami osób z grupy
- Dostajesz od innych, dajesz innym
- Otrzymujesz stałe wsparcie i moderację doświadczonego mentora
- Uczysz się i rozwijasz holistycznie przedsiębiorczość, strategię, finanse, przywództwo, komunikację i relacje, i inne, kluczowe dla Twojego sukcesu obszary liderskie 
- Rozwiązujesz konkretne zadania
- Pozyskujesz nową wiedzę i doświadczenia 
- Koncentrujesz się na ludziach, przedsięwzięciach i konkretnych potrzebach swoich i innych uczestniczek i uczestników
- Bierzesz udział w holistycznym ujmowaniu tematów
- Doświadczasz inspirujących spotkań warsztatowych
- Doświadczasz wyjątkowego procesu pracy i rozwoju
- Budujesz dobre życie: Twoje, Twojego zespołu, Twojej firmy.

# JAK ZORGANIZOWANA JEST PRACA
- Pracujesz w grupie 6-10 osób
- Twoim mentorem prowadzącym jest Tomasz Dalach [https://oceancapital.pl/mentoring/tomasz-dalach](https://oceancapital.pl/mentoring/tomasz-dalach)
- Bierzesz udział w regularnych, zorganizowanych spotkaniach stacjonarnych lub on-line w aplikacji Zoom ustalanych indywidualnie
- Ustalamy wspólnie częstotliwość: co 2 (dla spotkań 1,5h) lub co 4 (dla spotkań 3h) tygodnie, stałe dni i godziny tygodnia, np. piątek, godz. 9:00 lub 12:00 lub 15:00 
- Uzyskujesz nielimitowany kontakt i możliwość współpracy z uczestniczkami i uczestnikami
- Tworzysz grupę WhatsApp z udziałem innych uczestniczek, uczestników oraz mentora prowadzącego
- Pracujesz z tematami proponowanymi przez siebie oraz przez uczestniczki i uczestników,  stanowiącymi  wyzwania indywidualne lub organizacyjne każdej osoby lub firmy
- Pracujesz z tematami proponowanymi i przygotowywanymi przez mentora prowadzącego 
- Uzyskujesz wsparcie w organizacji nieformalnych spotkań grupy`,

	'/mastermind/grupy-i-kontakt': `
Rekrutacja przebiega ciągłe w trakcie roku kalendarzowego. Grupy tworzone są na bieżąco w uzgodnieniu z zainteresowanymi uczestniczkami i uczestnikami, mają charakter stały i zamknięty. Obecnie prowadzimy rekrutację na edycję 2024/2025.

Formowanie grup odbywa się w następujących etapach: 
- Spotkanie informacyjne
- Rozmowa z Mentorem prowadzącym o potrzebach i oczekiwaniach liderskich zainteresowanej osoby lub zespołu
- Uszczegółowienie programu tak, aby dostosować go do potrzeb Grupy
- Ustalenie harmonogramu spotkań
- Rozpoczęcie spotkań MASTERMIND

Jeśli MASTERMIND OCEAN CAPITAL może wesprzeć Ciebie, rozwój Twojego zespołu oraz biznesu, umów się na bezpłatne spotkanie informacyjne - kliknij [tutaj](https://oceancapital.pl/kontakt/umow-spotkanie).`,
};

export namespace MastermindPlusProps {
	export interface MastermindSidebarItem {
		value: string;
		link: string;
		children?: MastermindSidebarItem[];
	}

	export const masterMindPlusTitles: MastermindSidebarItem[] = [
		{
			value: 'Co otrzymujesz',
			link: '/mastermind+/co-otrzymujesz',
		},
		{
			value: 'Co nas wyróżnia',
			link: '/mastermind+/co-nas-wyroznia',
		},
		{
			value: 'Partnerzy programu',
			link: '/mastermind+/partnerzy-programu',
		},
		{
			value: 'Dla kogo jest Mastermind+',
			link: '/mastermind+/dla-kogo',
		},
		{
			value: 'Top korzyści dla Ciebie',
			link: '/mastermind+/top-korzysci',
		},
		{
			value: 'Dodatkowe korzyści',
			link: '/mastermind+/dodatkowe-korzysci',
		},
		{
			value: 'Przymierze umysłów',
			link: '/mastermind+/przymierze-umyslow',
		},
		{
			value: 'Eksperci Mastermind+',
			link: '/mastermind+/eksperci',
		},
		{
			value: 'Kalendarz zjazdów ',
			link: '/mastermind+/kalendarz-zjazdow',
		},
		{
			value: 'Tematy',
			link: '/mastermind+/tematy',
			children: [
				{
					value: 'Mastermind I',
					link: '/mastermind+/tematy/mastermind-i',
				},
				{
					value: 'Mastermind II',
					link: '/mastermind+/tematy/mastermind-ii',
				},
				{
					value: 'Mastermind III',
					link: '/mastermind+/tematy/mastermind-iii',
				},
				{
					value: 'Mastermind IV',
					link: '/mastermind+/tematy/mastermind-iv',
				},
				{
					value: 'Mastermind V',
					link: '/mastermind+/tematy/mastermind-v',
				},
				{
					value: 'Mastermind VI',
					link: '/mastermind+/tematy/mastermind-vi',
				},
				{
					value: 'Mastermind VII',
					link: '/mastermind+/tematy/mastermind-vii',
				},
				{
					value: 'Mastermind VIII',
					link: '/mastermind+/tematy/mastermind-viii',
				},
				{
					value: 'Mastermind IX',
					link: '/mastermind+/tematy/mastermind-ix',
				},
			],
		},
		{
			value: 'Certyfikat ukończenia',
			link: '/mastermind+/certyfikat-ukonczenia',
		},
		{
			value: 'Koszt uczestnictwa i zapisy',
			link: '/mastermind+/koszt-i-zapisy',
		},
		{
			value: 'Zapraszamy',
			link: '/mastermind+/zapraszamy',
		},
	];

	export const masterMindPlusLinkValues: MastermindPages = {
		'/mastermind+/co-otrzymujesz': 'Co otrzymujesz w Mastermind+',
		'/mastermind+/co-nas-wyroznia': 'Co nas wyróżnia',
		'/mastermind+/partnerzy-programu': 'Partnerzy programu',
		'/mastermind+/dla-kogo': 'Dla kogo jest Mastermind+',
		'/mastermind+/top-korzysci': 'Top korzyści dla Ciebie',
		'/mastermind+/dodatkowe-korzysci': 'Dodatkowe korzyści',
		'/mastermind+/przymierze-umyslow': 'Przymierze umysłów',
		'/mastermind+/eksperci': 'Eksperci Mastermind+',
		'/mastermind+/kalendarz-zjazdow': 'Kalendarz zjazdów',
		'/mastermind+/tematy/mastermind-i': 'Mastermind I',
		'/mastermind+/tematy/mastermind-ii': 'Mastermind II',
		'/mastermind+/tematy/mastermind-iii': 'Mastermind III',
		'/mastermind+/tematy/mastermind-iv': 'Mastermind IV',
		'/mastermind+/tematy/mastermind-v': 'Mastermind V',
		'/mastermind+/tematy/mastermind-vi': 'Mastermind VI',
		'/mastermind+/tematy/mastermind-vii': 'Mastermind VII',
		'/mastermind+/tematy/mastermind-viii': 'Mastermind VIII',
		'/mastermind+/tematy/mastermind-ix': 'Mastermind IX',
		'/mastermind+/certyfikat-ukonczenia': 'Certyfikat ukończenia',
		'/mastermind+/koszt-i-zapisy': 'Koszt uczestnictwa i zapisy',
		'/mastermind+/zapraszamy': 'Zapraszamy',
	};

	export const red: string = '#E71205';
	export const blue: string = '#1901C3';
	export const green: string = '#089258';

	export const masterMindPlusPageColors: MarkdownPages = {
		'/mastermind+/partnerzy-programu': green,
		'/mastermind+/co-otrzymujesz': blue,
		'/mastermind+/co-nas-wyroznia': blue,
		'/mastermind+/dla-kogo': blue,
		'/mastermind+/top-korzysci': blue,
		'/mastermind+/dodatkowe-korzysci': blue,
		'/mastermind+/przymierze-umyslow': blue,
		'/mastermind+/eksperci': red,
		'/mastermind+/kalendarz-zjazdow': green,
		'/mastermind+/tematy/mastermind-i': blue,
		'/mastermind+/tematy/mastermind-ii': green,
		'/mastermind+/tematy/mastermind-iii': red,
		'/mastermind+/tematy/mastermind-iv': blue,
		'/mastermind+/tematy/mastermind-v': green,
		'/mastermind+/tematy/mastermind-vi': red,
		'/mastermind+/tematy/mastermind-vii': blue,
		'/mastermind+/tematy/mastermind-viii': green,
		'/mastermind+/tematy/mastermind-ix': red,
		'/mastermind+/certyfikat-ukonczenia': '',
		'/mastermind+/koszt-i-zapisy': blue,
		'/mastermind+/zapraszamy': '',
	};

	export interface MarkdownPages {
		[key: string]: any;
		'/mastermind+/partnerzy-programu'?: string;
		'/mastermind+/co-otrzymujesz'?: string;
		'/mastermind+/co-nas-wyroznia'?: string;
		'/mastermind+/dla-kogo'?: string;
		'/mastermind+/top-korzysci'?: string;
		'/mastermind+/dodatkowe-korzysci'?: string;
		'/mastermind+/przymierze-umyslow'?: string;
		'/mastermind+/eksperci'?: string;
		'/mastermind+/kalendarz-zjazdow'?: string;
		'/mastermind+/tematy/mastermind-i'?: string;
		'/mastermind+/tematy/mastermind-ii'?: string;
		'/mastermind+/tematy/mastermind-iii'?: string;
		'/mastermind+/tematy/mastermind-iv'?: string;
		'/mastermind+/tematy/mastermind-v'?: string;
		'/mastermind+/tematy/mastermind-vi'?: string;
		'/mastermind+/tematy/mastermind-vii'?: string;
		'/mastermind+/tematy/mastermind-viii'?: string;
		'/mastermind+/tematy/mastermind-ix'?: string;
		'/mastermind+/certyfikat-ukonczenia'?: string;
		'/mastermind+/koszt-i-zapisy'?: string;
		'/mastermind+/zapraszamy'?: string;
	}

	export const noBigCircleRoutes: string[] = [
		'/mastermind+/partnerzy-programu',
		'/mastermind+/dla-kogo',
		'/mastermind+/zapraszamy',
		'/mastermind+/kalendarz-zjazdow',
	];

	export const noSmallCircleRoutes: string[] = ['/mastermind+/zapraszamy'];

	export const mastermindPlusTexts: MarkdownPages = {
		'/mastermind+/co-otrzymujesz': `
- Program, łączący eksperckie wykłady inspiracyjno-ukierunkowujące, proces grupowy w spotkaniach Mastermind+ oraz indywidualny mentoring liderski 1:1 z doświadczonymi mentorami biznesowymi
- **Ponad 50 godzin liderskich warsztatów**, prowadzonych w procesie  grupowym Mastermind+
- **9 spotkań stacjonarnych** na Wydziale Zarządzania Uniwersytetu Warszawskiego co ok. 3 tygodnie
- **5 indywidualnych sesji mentoringowych 1:1** z Aleksandrą Ślifirską i Tomaszem Dalachem dla każdej uczestniczki i uczestnika, realizowanych on-line
- Niezliczoną liczbę interakcji pomiędzy uczestniczkami i uczestnikami
- **7 miesięcy wspólnego rozwoju** kompetencji przywódczych 
- Stały dostęp do przymierza umysłów uczestniczek i uczestników oraz mentorów prowadzących
- Dostęp do konsultacji z wszystkimi ekspertami Mastermind+
- Wartościowy networking
- Bogatą ofertę tematów dodatkowych do wyboru
- Możliwość zgłaszania tematów przez uczestniczki i uczestników
- Możliwość kontynuacji pracy w kolejnych grupach Mastermind+
- Certyfikat ukończenia Mastermind+
		`,
		'/mastermind+/co-nas-wyroznia': `
- Tematy wybrane specjalnie dla liderek i liderów biznesów z doświadczenia tysięcy godzin pracy mentoringowej i szkoleniowej zespołu OCEAN CAPITAL
- Ujęcie tematów w kontekście firm uczestniczek i uczestników
- Rozwój liderek i liderów oraz ich biznesów w holistycznym połączeniu eksperckich wykładów, sesji Mastermind+ i mentoringu 1:1
- Połączenie psychologii przywództwa z twardymi wymaganiami oraz celami rozwoju biznesów
- Jakość i doświadczenie ekspertów
- Jakość i doświadczenie uczestników
- Partnerstwo Wydziału Zarządzania Uniwersytetu Warszawskiego
- Networking na poziomie Top Management
- Możliwość kontynuacji Mastermind+ z bogatą ofertą tematów OCEAN CAPITAL oraz z tematami uczestniczek i uczestników`,
		'/mastermind+/top-korzysci': `
- Zdefiniujesz siebie na nowo jako liderkę / lidera
- Przezwyciężysz samotność liderki / lidera
- Zmienisz perspektywę i  wywrócisz dotychczasowe koncepcje do góry nogami
- Pozbędziesz się micromanagementu, zajmiesz się tylko tym, co wynika z Twojej strategicznej roli 
- Podniesiesz skuteczność osobistą w relacjach z partnerami i pracownikami
- Przygotujesz i wdrożysz kluczowe dla Twojego biznesu zmiany i narzędzia liderskie
- Rozwiniesz i wzmocnisz kulturę dystrybucji odpowiedzialności w Twojej firmie 
- Wykorzystasz sztuczną inteligencję w rozwoju marketingu i sprzedaży
- Zbudujesz skuteczny i wspierający network 
- Odzyskasz spokój wewnętrzny
		`,
		'/mastermind+/dodatkowe-korzysci': `
- Sprawdzonych strategii, „success story”oraz „case study” innych liderek i liderów, jak również do lekcji, które dały im popełnione błędy. Od razu przetransferujesz je do Twojej firmy
- Wiedzy i doświadczenia uczestników, które pozwolą ci na bieżąco rozwiązywać Twoje wyzwania biznesowe oraz podejmować właściwe decyzje biznesowe
- Doświadczeń osób prowadzących – w 100% praktyków biznesu, z międzynarodową wiedzą doradczą i naukową
		`,
		'/mastermind+/przymierze-umyslow': `
MASTERMIND+ OCEAN CAPITAL jest cyklem regularnych spotkań warsztatowych grup współczesnych liderek i liderów. 

W MASTERMIND+ OCEAN CAPITAL udział biorą osoby reprezentujące różne branże i specjalizacje. Uczestniczki i uczestnicy tworzą „przymierze umysłów”, łącząc swoje kompetencje w celu rozwoju osobistego oraz realizacji konkretnych wyzwań liderskich i biznesowych. Podczas moderowanej przez mentorów pracy grupowej dochodzi do wymiany doświadczeń, wiedzy, pomysłów i kontaktów tak, aby wspierać, rozwijać i inspirować się nawzajem.


Każdy warsztat składa się z dwóch części: eksperckiego wykładu oraz pracy grupowej. Warsztaty odbywają się w formie stacjonarnej w budynku Wydziału Zarządzania Uniwersytetu Warszawskiego. Integralną częścią programu są również spotkania mentoringowe 1:1 z mentorami OCEAN CAPITAL, prowadzone w trybie on-line.


##### „Grupa mastermind” oraz „przymierze umysłów” to koncepcje wprowadzone przez autora i myśliciela Napoleona Hilla w jego książce "Myśl i bogać się" ("Think and Grow Rich").
		
		`,
	};

	export const KalendarzZjazdow: string[] = [
		`
## Mastermind I
3 kwietnia 2025, czwartek, godz. 11:00-16:30
- Spotkanie organizacyjno-zapoznawcze
- Część networkingowa z case studies firm
    `,
		`
## Mastermind II
24 kwietnia 2025, czwartek, godz. 11:00-16:30
- WszechTronny czy wszechstronny lider w organizacji?
- Ty jako liderka/lider oraz najlepsi liderzy w Twojej organizacji
    `,
		`
## Mastermind III
15 maja 2025, czwartek, godz. 11:00-16:30
- Styl komunikacji lidera jako czynnik sukcesu w prowadzeniu zespołu
- Czym jest komunikacja w Twojej firmie?
    `,
		`
## Mastermind IV
5 czerwca 2025, czwartek, godz. 11:00-16:30
- Budowanie i realizacja strategii organizacji
- Jaką strategię ma Twoja firma?
    `,
		`
## Mastermind V
26 czerwca 2025, czwartek, godz. 11:00-16:30
- AI jako narzędzie służące rozwojowi firmy
- Jak skutecznie wykorzystać AI w Twoim biznesie?
    `,
		`
## Mastermind VI
4 września 2025, czwartek, godz. 11:00-16:30
- Jak zarządzać zmianami w organizacji, aby nie położyć biznesu
- Sukcesy i porażki w zmianie
    `,
		`
## Mastermind VII
25 września 2025, czwartek, godz. 11:00-16:30
- Trójkąt dramatyczny w życiu firmowym i osobistym
- Znaczenie brania odpowiedzialności przez liderkę/lidera i przez pracowników
    `,
		`
## Mastermind VIII
16 października 2025, czwartek, godz. 11:00-16:30
- Jak przygotować Twoją Firmę do sprzedaży lub łączenia z inną?
- Sprzedaż firmy jako opcja wyjścia z inwestycji czy jej rozwój przez łączenie z inną – czy to jest dla Ciebie?
    `,
		`
## Mastermind IX
6 listopada 2025, czwartek, godz. 11:00-16:30
- Reputacja a marka osobista lidera
- Power Speech: Widoczność lidera i komunikowanie sukcesów.
- Wymiana doświadczeń ze wspólnej pracy wraz z sesją feedbackową, Networking.
- Wręczenie Certyfikatów
    `,
		`
## Lokalizacja: 

Wydział Zarządzania Uniwersytetu Warszawskiego

ul. Szturmowa 1/3

sala nr C104

bezpłatny parking
		`,
	];

	export interface MeetingCyclePart {
		tematPrzewodni: string;
		prowadzenie: string;
		duration: string;
	}

	export interface MastermindPlusMeetingCycle {
		pageTitle: string;
		pageId: number;
		korzysci: string;
		firstPart: MeetingCyclePart;
		secondPart: MeetingCyclePart;
		kiedy: string;
		obszar: string;
		lokalizacja: string;
	}

	export const MeetingCycleData: MastermindPlusMeetingCycle[] = [
		{
			pageTitle: 'Mastermind I',
			pageId: 0,
			korzysci: `
Podniesiesz skuteczność poprzez stosowanie kontraktu liderskiego

Rozpoczniesz budowanie nowego networku dla rozwiązań w Twojej firmie

Zwiększysz skuteczność budowania rozwiązań z techniką feedforward

Poznasz unikatowe wartości rozwoju swojej firmy

Zaprojektujesz pracę własną w Mastermind+
`,
			firstPart: {
				tematPrzewodni: 'Spotkanie organizacyjno-zapoznawcze',
				prowadzenie: 'Aleksandra Ślifirska, Tomasz Dalach MBA',
				duration: '1,5 godz',
			},
			secondPart: {
				tematPrzewodni: 'Spotkanie networkingowe z case studies firm',
				prowadzenie: 'Aleksandra Ślifirska, Tomasz Dalach MBA',
				duration: '2,5 godz',
			},
			kiedy: '3 kwietnia 2025, czwartek	  |    godz. 11:00-16:30 z przerwą na wspólny lunch	',
			obszar: 'Formowanie grupy, rozpoczęcie procesu grupowego, networking	',
			lokalizacja: 'Wydział Zarządzania Uniwersytetu Warszawskiego, ul. Szturmowa 1/3, sala nr	C104',
		},
		{
			pageTitle: 'Mastermind II',
			pageId: 1,
			korzysci: `
Osiągniesz skuteczność w przewodzeniu innymi i wyższe flow z ludźmi w organizacji

Odzyskasz więcej czasu dla siebie i dla Twojego zespołu

Wzmocnisz zespół i zdelegujesz pracę

Sprawisz, że ludzie, z którymi pracujesz, zauważą w Tobie zmianę i zaczną Tobie bardziej ufać

Zaufasz sam sobie

Wyjdziesz z tunelu i będziesz patrzyła/patrzył szerzej

Nie będziesz bała/bał się rozmawiać o trudnych rzeczach

Zostawisz sobie to, co powinien mieć lider lub liderka i ani trochę więcej`,
			firstPart: {
				tematPrzewodni: 'WszechTronny czy wszechstronny lider w organizacji?',
				prowadzenie: 'Tomasz Dalach MBA',
				duration: '1,5 godz',
			},
			secondPart: {
				tematPrzewodni: 'Ty jako liderka/lider oraz najlepsi liderzy w Twojej organizacji',
				prowadzenie: 'Tomasz Dalach MBA',
				duration: '2,5 godz',
			},
			kiedy: '24 kwietnia 2025, czwartek		  |    godz. 11:00-16:30 z przerwą na wspólny lunch	',
			obszar: 'Leadership/HR',
			lokalizacja: 'Wydział Zarządzania Uniwersytetu Warszawskiego, ul. Szturmowa 1/3, sala nr	C104',
		},
		{
			pageTitle: 'Mastermind III',
			pageId: 2,
			korzysci: `
Zmotywujesz i zaangażujesz menedżerów i ich zespoły do sprawczego działania  poprzez budowanie trwałych relacji z ludźmi

Zbudujesz mapę interesariuszy komunikacji w Twojej organizacji

Zdefiniujesz komunikację, budującą wartości w Twojej firmie

Poznasz wiodące style komunikacji i rozwiniesz swój własny styl komunikacji liderskiej

Dowiesz się jak inne firmy zarządzają komunikacją`,
			firstPart: {
				tematPrzewodni: 'Styl komunikacji lidera jako czynnik sukcesu w prowadzeniu zespołu',
				prowadzenie: 'Aleksandra Ślifirska ',
				duration: '1,5 godz',
			},
			secondPart: {
				tematPrzewodni: 'Czym jest komunikacja w Twojej firmie?',
				prowadzenie: 'Aleksandra Ślifirska, Tomasz Dalach MBA',
				duration: '2,5 godz',
			},
			kiedy: '15 maja 2025, czwartek  |   godz. 11:00-16:30 z przerwą na wspólny lunch  ',
			obszar: 'Komunikacja',
			lokalizacja: 'Wydział Zarządzania Uniwersytetu Warszawskiego, ul. Szturmowa 1/3, sala nr	C104',
		},
		{
			pageTitle: 'Mastermind IV',
			pageId: 3,
			korzysci: `
Rozwiniesz siebie w roli strategicznego lidera

Poznasz właściwości nowoczesnej strategii firmy

Dowiesz się dlaczego Twoja organizacja potrzebuje strategii

Poznasz, jak najskuteczniej budować i wdrażać strategię w Twojej firmie

Poznasz strategie i wyzwania strategiczne innych firm`,
			firstPart: {
				tematPrzewodni: 'Budowanie i realizacja strategii organizacji',
				prowadzenie: 'dr Tomasz Ludwicki',
				duration: '1,5 godz',
			},
			secondPart: {
				tematPrzewodni: 'Jaką strategię ma Twoja firma?',
				prowadzenie: 'dr Tomasz Ludwicki, Tomasz Dalach MBA',
				duration: '2,5 godz',
			},
			kiedy: '5 czerwca 2025, czwartek	 |   godz. 11:00-16:30 z przerwą na wspólny lunch	',
			obszar: 'Strategia',
			lokalizacja: 'Wydział Zarządzania Uniwersytetu Warszawskiego, ul. Szturmowa 1/3, sala nr	C104',
		},
		{
			pageTitle: 'Mastermind V',
			pageId: 4,
			korzysci: `
Poznasz, jak wykorzystywać AI w budowaniu wartości Twojej firmy

Poznasz jak wykorzystać AI do rozwoju marketingu i sprzedaży

Poznasz najnowsze trendy w AI

Dowiesz się jakie zagrożenia wiążą się z AI i jak zabezpieczyć przed nimi swój biznes

Dowiesz się jak inne firmy wykorzystują AI

Zaplanujesz wdrożenie AI w swoim biznesie`,
			firstPart: {
				tematPrzewodni: 'AI jako narzędzie służące rozwojowi firmy',
				prowadzenie: 'Jan Maria Kowalski MBA',
				duration: '1,5 godz',
			},
			secondPart: {
				tematPrzewodni: 'Jak skutecznie wykorzystać AI w Twoim biznesie?',
				prowadzenie: 'Jan Maria Kowalski MBA, Tomasz Dalach MBA',
				duration: '2,5 godz',
			},
			kiedy: '26 czerwca 2025, czwartek	 	 |    godz. 11:00-16:30 z przerwą na wspólny lunch 	',
			obszar: 'Sztuczna inteligencja',
			lokalizacja: 'Wydział Zarządzania Uniwersytetu Warszawskiego, ul. Szturmowa 1/3, sala nr	C104',
		},
		{
			pageTitle: 'Mastermind VI',
			pageId: 5,
			korzysci: `
Rozwiniesz kompetencje liderskie, służące wdrażaniu zmian w organizacji

Zaplanujesz zmianę w swojej firmie

Nauczysz się jak to robić, żeby zmiana nie bolała, nie trwała za długo i nie kosztowała zbyt dużo

Poznasz psychologiczne aspekty zmian

Poznasz przykłady udanych i nieudanych zmian

Dowiesz się jak inne firmy wdrażają skuteczne zmiany`,
			firstPart: {
				tematPrzewodni: 'Jak zarządzać zmianami w organizacji, aby nie położyć biznesu',
				prowadzenie: 'Paweł Dudek',
				duration: '1,5 godz',
			},
			secondPart: {
				tematPrzewodni: 'Sukcesy i porażki w zmianie',
				prowadzenie: 'Paweł Dudek, Tomasz Dalach MBA',
				duration: '2,5 godz',
			},
			kiedy: '4 września 2025, czwartek	 |    godz. 11:00-16:30 z przerwą na wspólny lunch',
			obszar: 'Zarządzanie zmianą',
			lokalizacja: 'Wydział Zarządzania Uniwersytetu Warszawskiego, ul. Szturmowa 1/3, sala nr	C104',
		},
		{
			pageTitle: 'Mastermind VII',
			pageId: 6,
			korzysci: `
Zrozumiesz lepiej, jak i co komunikują Twoi pracownicy

Będziesz wiedziała/wiedział jak mówić do ludzi, aby byli efektywni

Będziesz skuteczniej kształtował pożądaną kulturę firmy

Sprawisz, aby wszyscy skupiali się, zarówno na tym CO robimy, ale i JAK robimy

Rozwiniesz delegowanie odpowiedzialności w Twojej firmie

Poznasz sprawdzone metody budowy odpowiedzialności w innych firmach`,
			firstPart: {
				tematPrzewodni: 'Trójkąt dramatyczny w życiu firmowym i osobistym',
				prowadzenie: 'Tomasz Dalach MBA',
				duration: '1,5 godz',
			},
			secondPart: {
				tematPrzewodni: 'Znaczenie brania odpowiedzialności przez liderkę/lidera i przez pracowników',
				prowadzenie: 'Tomasz Dalach MBA',
				duration: '2,5 godz',
			},
			kiedy: '25 września 2025, czwartek 	 |    godz. 11:00-16:30 z przerwą na wspólny lunch',
			obszar: 'Leadership/HR',
			lokalizacja: 'Wydział Zarządzania Uniwersytetu Warszawskiego, ul. Szturmowa 1/3, sala nr	C104',
		},
		{
			pageTitle: 'Mastermind VIII',
			pageId: 7,
			korzysci: `
Dowiesz się, jakie są czynniki sukcesu i przyczyny niepowodzeń w procesie M&A

Poznasz fazy transakcji i reguły procesu przejmowania lub sprzedaży firmy

Poznasz rolę zespołu doradców branżowych, finansowych, prawnych i innych w procesie przejęcia lub łączenia firm oraz ich sprzedaży

Poznasz drivery wzrostu wartości i ceny firmy w procesie M&A

Otrzymasz wskazówki, jak przygotować Twoją Firmę do całego procesu`,
			firstPart: {
				tematPrzewodni: 'Jak przygotować Twoją Firmę do sprzedaży lub łączenia z inną?',
				prowadzenie: 'prof. Mieczysław Grudziński',
				duration: '1,5 godz',
			},
			secondPart: {
				tematPrzewodni: 'Sprzedaż firmy jako opcja wyjścia z inwestycji czy jej rozwój przez łączenie z inną – czy to jest dla Ciebie?',
				prowadzenie: 'prof. Mieczysław Grudziński, Tomasz Dalach MBA',
				duration: '2,5 godz',
			},
			kiedy: '16 października 2025,  czwartek 	 |    godz. 11:00-16:30 z przerwą na wspólny lunch',
			obszar: 'Finanse i zarządzanie',
			lokalizacja: 'Wydział Zarządzania Uniwersytetu Warszawskiego, ul. Szturmowa 1/3, sala nr	C104',
		},
		{
			pageTitle: 'Mastermind IX',
			pageId: 8,
			korzysci: `
Otrzymasz feedback, który pozwoli ci na jeszcze skuteczniejsze korekty w pracy z ludźmi

Zbudujesz reputację w swoim środowisku biznesowym, która jest czynnikiem sukcesu

Zaplanujesz dalszy rozwój własny

Zaplanujesz dalszy rozwój swojej firmy

Uzyskasz Certyfikat MASTERMIND OCEAN CAPITAL`,
			firstPart: {
				tematPrzewodni: 'Reputacja a marka osobista lidera',
				prowadzenie: 'Aleksandra Ślifirska',
				duration: '1,5 godz',
			},
			secondPart: {
				tematPrzewodni:
					'Power Speech: Widoczność lidera i komunikowanie sukcesów. Wymiana doświadczeń ze wspólnej pracy wraz  z sesją feedbackową, Networking.',
				prowadzenie: 'Aleksandra Ślifirska, Tomasz Dalach MBA',
				duration: '2,5 godz',
			},
			kiedy: '6 listopada 2025 	 |    godz. 11:00-16:30 z przerwą na wspólny lunch',
			obszar: 'Marka osobista, Feedback, Networking',
			lokalizacja: 'Wydział Zarządzania Uniwersytetu Warszawskiego, ul. Szturmowa 1/3, sala nr C104	',
		},
	];

	export const mastermindMeetingCycleColors: string[] = [blue, green, red, blue, green, red, blue, green, red];
}
